import React, { useLayoutEffect, type ReactNode } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useForm } from '../context/FormContext';

const FORM_PATHS = new Set(['/applications', '/incidents', '/additional-info']);

/**
 * Prevents opening step 2 / 3 via URL before the server draft has advanced past step 1 (or 2).
 * Redirects to the furthest allowed route for the current `draftCurrentStep`.
 */
export function FormRouteGuard({ children }: { children: ReactNode }): JSX.Element {
  const location = useLocation();
  const navigate = useNavigate();
  const { draftReady, draftCurrentStep } = useForm();

  useLayoutEffect(() => {
    if (!draftReady) return;
    const path = location.pathname;
    if (!FORM_PATHS.has(path)) return;

    const step = (draftCurrentStep ?? 'application').trim().toLowerCase();

    if (path === '/incidents' && step === 'application') {
      navigate('/applications', { replace: true });
      return;
    }

    if (path === '/additional-info') {
      if (step === 'application') {
        navigate('/applications', { replace: true });
        return;
      }
      if (step === 'incident') {
        navigate('/incidents', { replace: true });
        return;
      }
    }
  }, [draftReady, draftCurrentStep, location.pathname, navigate]);

  return <>{children}</>;
}
